__turbopack_context__.v({
  "panelHeader": "PanelHeader-module__cQw7wa__panelHeader",
});
